export default __webpack_public_path__ + "static/media/disc_init.84c8a8cf.png";